import fetch from "auth/FetchInterceptor";

const authUserPermissisonService = {};

authUserPermissisonService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/auth-permission",
		method: "get",
		params,
	});
};

authUserPermissisonService.post = function (data) {
	return fetch({
		url: "/v1/rest/auth-permission",
		method: "post",
		data: data,
	});
};

authUserPermissisonService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/auth-permission/${id}`,
		method: "put",
		data: data,
	});
};

authUserPermissisonService.getById = function (id) {
	return fetch({
		url: `/v1/rest/auth-permission/${id}`,
		method: "get",
	});
};

export default authUserPermissisonService;
